import React from 'react';

import { H1PlusSmall } from '@repo/ui-kit/components/core/Typography';

import { LandingButton } from '../../landingButton';
import LandingImage from '../../shared/LandingImage';
import { buttonAnalyticsMeta } from '../config';
import { Description } from '../Description';

import { TextSection, Text, ImageWrapper } from './styles';
import { VariationProps } from './types';

export const CenterVariation: React.FC<VariationProps> = ({
  title,
  description,
  button,
  image,
  imageSize,
  buttonMeta,
}) => {
  return (
    <>
      <TextSection>
        <Text>
          <H1PlusSmall textAlign="center">{title}</H1PlusSmall>
          <Description alignCenter={true} description={description} />
        </Text>
        {button && (
          <LandingButton
            analyticsMeta={buttonMeta ?? buttonAnalyticsMeta}
            isSignUp={button.isSignUp}
            label={button.label}
            url={button.url}
          />
        )}
      </TextSection>
      <ImageWrapper imageSize={imageSize}>
        <LandingImage
          fill
          alt={image.alt ?? 'image'}
          provider={image.provider}
          src={image.url}
          style={{ objectFit: 'cover' }}
        />
      </ImageWrapper>
    </>
  );
};
